/**
 * Referral Settings Page
 * Manages friend-referral reward-day configuration.
 */

import { Gift } from 'lucide-react';
import { useI18n } from '@/i18n';
import { ReferralSettingsTab } from '@/features/referral/components/ReferralSettingsTab';

export function ReferralSettingsPage() {
  const { t } = useI18n();

  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <Gift className="w-8 h-8 text-primary" />
        <div>
          <h1 className="text-2xl font-bold text-foreground">{t('referralPage.pageTitle')}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t('referralPage.pageDescription')}</p>
        </div>
      </div>

      <ReferralSettingsTab />
    </div>
  );
}
